import { useState } from "react";
import ArrowRight from "../Icons/ArrowRight";
import FacebookIcon from "../Icons/social/FacebookIcon";
import InstagramIcon from "../Icons/social/InstagramIcon";
import TwitterIcon from "../Icons/social/TwitterIcon";
import YoutubeIcon from "../Icons/social/YoutubeIcon";
import styles from "./index.css";

const MiniFooter = (props) => {
  return (
    <>
      <div className="mini-footer-root">
        <footer>
          <div className="container">
            <div className="footer-content">
              <div className="footer-content-contact">
                <a href="#" target="_blank">
                  Contact us <ArrowRight size="20" />{" "}
                </a>
              </div>
              <div className="footer-content-social">
                <span>Follow us</span>
                <a href="#" target="_blank">
                  <FacebookIcon size="18" />
                </a>
                <a href="#" target="_blank">
                  <InstagramIcon size="18" />
                </a>
                <a href="#" target="_blank">
                  <TwitterIcon size="18" />
                </a>
                <a href="#" target="_blank">
                  <YoutubeIcon size="18" />
                </a>
              </div>
              <div className="footer-content-copy">
                <p>&copy; {new Date().getUTCFullYear()} 1Government.</p>
              </div>
            </div>
          </div>
        </footer>
      </div>

      <style jsx>{styles}</style>
    </>
  );
};

export default MiniFooter;
